import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { IToast } from '../../core/Toast';
import styles from './Toasts.module.css';

interface Props {
  items: IToast[];
  className?: string;
}

export const Toasts: FunctionComponent<Props> = ({ items, className }) => (
  <div className={classNames(styles.component, className)}>
    <ul className={styles.list}>
      {items.map((toast: IToast) => (
        <li key={toast.id} className={styles.item}>
          <div className={classNames(styles.toast, styles[toast.type])}>
            {toast.title && <span className={styles.title}>{toast.title}</span>}
            <span className={styles.message}>{toast.message}</span>
          </div>
        </li>
      ))}
    </ul>
  </div>
);
